import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const BookMeetingPage = () => {
  useEffect(() => {
    // Load HubSpot Meetings Embed Script
    const script = document.createElement('script');
    script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-black">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="inline-block">
            <img 
              src="https://customer-assets.emergentagent.com/job_cashflow-596/artifacts/ipba3h4w_Gazeal%20Advance%20logo.png" 
              alt="Gazeal Advance" 
              className="h-8"
            />
          </Link>
          <a 
            href="https://advance.gazeal.co.uk" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white/60 hover:text-[#57D961] text-sm transition-colors"
          >
            Learn more about Gazeal Advance →
          </a>
        </div>
      </header>

      <main className="pt-28 pb-12">
        <div className="max-w-4xl mx-auto px-6">
          {/* Header Text */}
          <div className="text-center mb-10">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Get Paid at <span className="text-[#57D961]">Sale Agreed</span>
            </h1>
            <p className="text-white/70 text-lg max-w-2xl mx-auto">
              Book a discovery session to learn how Gazeal Advance can help you access your commission early.
            </p>
          </div>

          {/* Info Box */}
          <div className="mb-10">
            <div className="relative bg-gradient-to-r from-[#57D961]/10 via-[#57D961]/5 to-[#57D961]/10 border border-[#57D961]/30 rounded-xl p-6 text-center shadow-[0_0_30px_rgba(87,217,97,0.15)]">
              <p className="text-white text-lg font-medium">
                Exclusive to Gazeal Agents. We are speaking with several agents daily to help them protect their commission and get paid faster.
              </p>
            </div>
          </div>

          {/* Calendar Embed */}
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 p-4 md:p-6">
            <div className="meetings-iframe-container rounded-xl overflow-hidden" data-src="https://meetings.hubspot.com/bryan-mansell/gazeal-advance?embed=true" style={{minHeight: '580px'}}></div>
          </div>

          {/* Bottom CTA */}
          <div className="text-center mt-8">
            <p className="text-white/50 text-sm mb-3">Want to learn more before booking?</p>
            <a 
              href="https://advance.gazeal.co.uk" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/15 border border-white/20 rounded-full text-white text-sm font-medium transition-all"
            >
              Visit Gazeal Advance Website
              <span>→</span>
            </a>
          </div>
        </div>
      </main>
    </div>
  );
};

export default BookMeetingPage;
